import React, { useEffect, useState } from 'react'
import Topbar from '../components/Topbar'
import Sidebar from '../components/Sidebar'
import styles from '../assets/css/ParkTicket.module.css'
import { FaTicketAlt, FaFileAlt } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'

function ParkTicket() {
  const navigate = useNavigate()
  const [parks, setParks] = useState([])

 useEffect(() => {
  const fetchParkData = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/ParkList`,{
        method: 'POST',
      });
      const data = await response.json();
      setParks(data.park_list);
    } catch (error) {
      console.error('Error fetching park data:', error);
    }
  };
  fetchParkData();
}, []);

  const handleViewReport = (parkId, parkName) => {
    navigate(`/park-ticket-details/${parkId}/${parkName}`);
  }

  return (
    <>
      <Topbar/>
      <div className='d-flex'>
        <Sidebar/>
        <div className={styles.parkContainer}>
          <div className={styles.parkContent}>
            <h2 className={styles.pageTitle}>Park Tickets</h2>
            <div className={styles.cardGrid}>
              {parks.map((park, index) => (
                <div key={index} className={styles.parkCard}>
                  <div className={styles.iconWrapper}>
                    <FaTicketAlt />
                  </div>
                  <div className={styles.parkInfo}>
                    <h3 className={styles.parkName}>{park.park_name}</h3>
                    <p className={styles.parkLocation}>{park.address}</p>
                    <button 
                      className={styles.viewReportBtn}
                      onClick={() => handleViewReport(park.park_id, park.park_name)}
                    >
                      <FaFileAlt className={styles.reportIcon} />
                      View Report
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ParkTicket 